import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-daeho-contact",
  data: function() {
    return {
      user_name: "",
      user_email: "",
      user_text: "",
      user_call: "",
      user_name1: "",
      user_email1: "",
      user_text1: "",
      user_call1: "",
      viewModel: {}
    };
  },
  mounted: function() {
    try {
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnClickMail: function() {
      let vm = this;
      if (!vm.isValidEmail(vm.user_email)) {
        alert("연락받을 메일의 형식이 틀렸습니다.");
        return false;
      }
      Axios.post("/daehounc/mail", { user_name: vm.user_name, user_email: vm.user_email, user_text: vm.user_text, user_call: vm.user_call })
        .then(function(response) {
          alert("메일이 발송되었습니다.");
          location.reload();
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    fnClickMail1: function() {
      let vm = this;
      if (!vm.isValidEmail(vm.user_email1)) {
        alert("연락받을 메일의 형식이 틀렸습니다.");
        return false;
      }
      Axios.post("/daehounc/mail1", { user_name: vm.user_name1, user_email: vm.user_email1, user_text: vm.user_text1, user_call: vm.user_call1 })
        .then(function(response) {
          alert("메일이 발송되었습니다.");
          location.reload();
        })
        .catch(function(ex) {
          console.log(ex);
        });
    },
    isValidEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    }
  }
});



// WEBPACK FOOTER //
// ./src/uz/daehounc/daehounc-contact-controller.js